module.exports = __webpack_public_path__ + "img/image79.3cf85af5.png";